import { FunctionComponent, useRef, useEffect } from 'react';
import RailzConnect from '@railzai/railz-connect';
import RailzConnectType from './railz-connect';
import styles from './RailzConnect.module.scss';

export type RailzConnectProps = {
  redirectURL: string;
  widgetId: string;
  businessName: string;
};
type FC = FunctionComponent<RailzConnectProps>;

const RailzConnectFrame: FC = ({ redirectURL, widgetId, businessName }: RailzConnectProps) => {
  const ref = useRef(null);

  useEffect(() => {
    const widget: RailzConnectType = new (RailzConnect as typeof RailzConnectType)();

    widget.mount({
      parentElement: ref.current,
      widgetId,
      businessName,
      brandColor: '000000',
      accentColor: 'FFFFFF',
      language: 'en',
      redirectUrl: `${redirectURL}`,
      closeRedirectUrl: `${redirectURL}`,
      removeRailzWatermark: true,
      closeEnabled: true,
    });
  }, []);

  return <div className={styles.railzConnectContainer} id="railz-connect" ref={ref} />;
};

export default RailzConnectFrame;
